import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useInView } from 'react-intersection-observer';

const Bar = styled.section`
  background: linear-gradient(90deg, #0a5a32 0%, #0e6b3c 50%, #0a5a32 100%);
  padding: 48px 0;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;
  max-width: var(--container-width);
  margin: 0 auto;
  padding: 0 var(--container-padding);

  @media (max-width: 968px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const Stat = styled.div`
  text-align: center;
  color: #fff;

  .icon {
    width: 44px;
    height: 44px;
    margin: 0 auto 12px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #f2b705;
    font-size: 1.1rem;
  }

  strong {
    display: block;
    font-family: var(--font-display);
    font-size: clamp(1.6rem, 2.5vw, 2rem);
    font-weight: 800;
    margin-bottom: 4px;
  }

  span {
    font-size: 0.82rem;
    opacity: 0.9;
  }
`;

function useCounter(end, active, duration = 1800) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!active) return;
    const t0 = performance.now();
    const tick = (now) => {
      const p = Math.min((now - t0) / duration, 1);
      setVal(Math.floor((1 - (1 - p) ** 3) * end));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [end, active, duration]);
  return val;
}

const stats = [
  { icon: 'fas fa-check-circle', end: 50, suffix: '+', label: 'Projects Completed' },
  { icon: 'fas fa-users', end: 30, suffix: '+', label: 'Happy Clients' },
  { icon: 'fas fa-calendar-alt', end: 5, suffix: '+', label: 'Years Experience' },
  { icon: 'fas fa-heart', end: 100, suffix: '%', label: 'Client Satisfaction' },
  { icon: 'fas fa-headset', end: 24, suffix: '/7', label: 'Support Available', raw: true },
];

const StatsBar = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });
  return (
    <Bar ref={ref}>
      <Grid>
        {stats.map((s) => (
          <StatItem key={s.label} stat={s} active={inView} />
        ))}
      </Grid>
    </Bar>
  );
};

function StatItem({ stat, active }) {
  const count = useCounter(stat.end, active && !stat.raw);
  return (
    <Stat>
      <div className="icon"><i className={stat.icon} /></div>
      <strong>{stat.raw ? '24/7' : `${count}${stat.suffix}`}</strong>
      <span>{stat.label}</span>
    </Stat>
  );
}

export default StatsBar;
